import { render, staticRenderFns } from "./UserCoupon.vue?vue&type=template&id=0ea18950&"
import script from "./UserCoupon.vue?vue&type=script&lang=js&"
export * from "./UserCoupon.vue?vue&type=script&lang=js&"
import style0 from "./UserCoupon.vue?vue&type=style&index=0&id=0ea18950&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports